export const WORKSPACE_CUSTOM_DOMAINS_QUERY_KEY = ['workspaceCustomDomains'] as const;

export function buildTenantCustomDomainsQueryKey(tenantId: string): readonly string[] {
  return ['tenantCustomDomains', tenantId];
}
